import * as React from 'react';

type CloseAction = () => void;

interface ProviderProps {
  children?: React.ReactNode;
  closeAction: CloseAction;
}

const DialogCloseContext = React.createContext<CloseAction>(() => {});

export function useDialogClose() {
  const context = React.useContext(DialogCloseContext);

  if (context === undefined) {
    throw new Error('useDialogClose must be used within a Dialog component');
  }

  return context;
}

export function DialogCloseProvider(props: ProviderProps) {
  return (
    <DialogCloseContext.Provider value={props.closeAction}>
      {props.children}
    </DialogCloseContext.Provider>
  );
}
